import React from 'react'
import EditableComponent from './EditableComponent'
import OffsetInput from './OffsetInput'
import { Col, Row } from 'reactstrap'

class DailyDatePicker extends EditableComponent {
  shouldRenderEditButton () { return this.props.editingEnabled === true && this.props.isDueDate === true }
  renderControl () {
    let text = this.props.localize('Reporting.Daily')
    if (this.isEdited()) {
      return <Row className='f1'>
        <Col sm='6'>{this.renderReadOnlyText(text)}</Col>
        <Col sm='6'>{!!this.props.isDueDate && <OffsetInput disabled={this.props.disabled} value={this.props.offset} onChange={offset => this.props.onOffsetChange(offset)} allowNegative />}</Col>
      </Row>
    }
    if (this.props.isDueDate) {
      text = `${text}${this.formatOffset(this.props.offset)}`
    }
    return this.renderReadOnlyText(text)
  }
}

export default DailyDatePicker



// WEBPACK FOOTER //
// ./src/components/Editors/DailyDatePicker.js